export const DEFAULT_403_TITLE = "403 - You shall not pass!";
export const DEFAULT_403_DESCRIPTION =
  "You are not authorized for this action. We've refreshed the page, if this persists let us know!";
export const DEFAULT_DEBOUNCE_DELAY = 2000;
export { EMAIL_FROM as DEFAULT_EMAIL_FROM } from "../../packages/email/config";
export const DEFAULT_ERROR_TITLE = "Uh, oh! Something went wrong";
export const DEFAULT_MISSING_PERMISSION_TITLE =
  "Hold up! You're not cleared for this";
export const DEFAULT_ORGANIZATION_UPDATED_TITLE =
  "All Set! Organization Updated";
export const DEFAULT_ORG_AVATAR = "/orgs/iceberg.svg";
export const DEFAULT_SETTINGS_CHANGED_TITLE = "All Set! Settings Changed";

export const ERROR_UNAUTHORIZED_ORG_ACCESS =
  "Unauthorized to access this organization";

export const LIBUM_DEV_MAIL_URL = "mailto:development@libum.io";
export const LIBUM_DISCORD_URL = "https://discord.gg/libum";
export const LIBUM_DOCS_GLACI_URL = "https://docs.libum.io/glaci";
export const LIBUM_DOCS_POWERON_PRO_URL = "https://docs.libum.io/poweron-pro";
export const LIBUM_DOCS_POWERON_PRO_CAPABILITIES_URL =
  "https://docs.libum.io/poweron-pro/capabilities";
export const LIBUM_DOCS_POWERON_PIPELINES_URL =
  "https://docs.libum.io/poweron-pipelines";
export const LIBUM_DOCS_NEXUM_URL = "https://docs.libum.io/nexum";
export const LIBUM_FEEDBACK_URL = "https://feedback.libum.io";
export const LIBUM_GITHUB_URL = "https://github.com/libum-llc";
export const LIBUM_GLACI_URL = "https://libum.io/glaci";
export const LIBUM_MEDIA_URL = "https://libum-media.s3.us-east-2.amazonaws.com";
export const LIBUM_ICON_URL =
  "https://libum-media.s3.us-east-2.amazonaws.com/libum.png";
export const LIBUM_IMAGE_PARTIAL_URL = `${LIBUM_MEDIA_URL}/1200x630_social_card`; // requires _{socialCard}.png
export const LIBUM_LINKEDIN_URL = "https://linkedin.com/company/libum";
export const LIBUM_PORTAL_URL = "https://portal.libum.io";
export const LIBUM_POWERON_PRO_OFFERINGS =
  "https://libum.io/poweron-pro#offerings";
export const LIBUM_POWERON_PIPELINES_FEATURES_URL =
  "https://libum.io/poweron-pipelines#features";
export const LIBUM_POWERON_PRO_INSTALL_URL =
  "vscode:extension/libum.poweron-pro";
export const LIBUM_POWERON_PRO_EULA_URL = "https://libum.io/legal/poweron-pro";
export const LIBUM_POWERON_PIPELINES_MARKETPLACE_URL =
  "https://marketplace.visualstudio.com/items?itemName=libum.poweron-pipelines";
export const LIBUM_URL = "https://libum.io";
export const LIBUM_AVATAR_NAMES = [
  "moose.svg",
  "narwhal.svg",
  "orca.svg",
  "penguin.svg",
  "polar_bear.svg",
  "puffin.svg",
  "seal.svg",
  "siberian_husky.svg",
  "snow_leopard.svg",
  "snow_owl.svg",
  "walrus.svg",
  "arctic_fox.svg",
  "arctic_rabbit.svg",
  "explorer_bust_orange.svg",
  "explorer_bust_red.svg",
  "explorer_bust_teal.svg",
  "explorer_bust_yellow.svg",
  "explorer_green.svg",
  "explorer_orange.svg",
  "explorer_pink.svg",
  "explorer_yellow.svg",
];
export const LIBUM_ORG_AVATAR_NAMES = [
  "bouy.svg",
  "cargoship.svg",
  "globe.svg",
  "iceberg.svg",
  "northern_lights.svg",
  "snow_goggles.svg",
  "igloo.svg",
  "lighthouse.svg",
  "arctic_cabin.svg",
  "compass.svg",
  "snowflake.svg",
  "expedition_sled.svg",
];

export const LIBUM_AVATARS = LIBUM_AVATAR_NAMES.map((filename) => ({
  src: `/avatars/${filename}`,
  name: filename
    .replace(".svg", "")
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" "),
}));

export const LIBUM_ORG_AVATARS = LIBUM_ORG_AVATAR_NAMES.map((fileName) => ({
  src: `/orgs/${fileName}`,
  name: fileName
    .replace(".svg", "")
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" "),
}));

export const REGEX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const UNITED_STATES = new Set([
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
]);

export const MARKDOWN_URL = "https://www.markdownguide.org/basic-syntax/";

export { STRIPE_API_VERSION } from "../../packages/stripe/config";
export const STRIPE_URL = "https://stripe.com";

export const TAILWIND_SHAKE_ANIMATION_DELAY = 300;
